import React, { forwardRef } from 'react'
import { SvgIcon, useTheme } from '@mui/material'

/**
 * The CircleSuccessIcon's component.
 */
const CircleSuccessIcon = forwardRef((props, ref) => {
  const { palette } = useTheme()

  return (
    <SvgIcon
      {...props}
      height="48px"
      ref={ref}
      version="1.1"
      viewBox="0 0 47 48"
      width="47px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="CircleSuccessIcon" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-616.000000, -419.000000)">
          <g transform="translate(489.000000, 379.000000)">
            <g transform="translate(127.000000, 40.000000)">
              <g transform="translate(0.000000, 0.500000)">
                <circle cx="23.5" cy="23.5" fill={palette.brand.white} r="23.5" />
                <g fill={palette.brand.success} opacity="0.2">
                  <circle cx="23.5" cy="23.5" r="23.5" />
                </g>
                <path
                  d="M32.5299927,18.9612216 L22.7996794,29.4913585 C22.173003,30.1695472 21.1584604,30.1695472 20.5333868,29.4913585 L16.4688052,25.0944062 C15.8437316,24.4162176 15.8437316,23.3182804 16.4688052,22.6400917 C17.0954817,21.9636375 18.1100243,21.9636375 18.7350979,22.6400917 L21.6665331,25.8124884 L30.2637,16.5086415 C30.8887737,15.8304528 31.9033163,15.8304528 32.5299927,16.5086415 C33.1566691,17.1850957 33.1566691,18.2830329 32.5299927,18.9612216"
                  fill={palette.brand.success}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  )
})

export default CircleSuccessIcon
